import ShareListingDialog from 'components/share-listing-dialog/share-listing-dialog';
import { Button, Dialog, Text } from 'components/ui';
import { ListingRead } from 'lib/api/generated';
import { buildPublicListingPath } from 'lib/listing-utils';
import { signIn } from 'next-auth/react';
import { useRouter } from 'next/router';
import { rgba } from 'polished';
import { useEffect, useState } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { REDIRECT_URL } from 'settings/config';
import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';
import { globalTheme } from 'styles/global-theme';

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  padding: 40px;
  @media screen and (max-width: ${breakpoints.medium}) {
    padding: 0px;
    margin-top: 15px;
  }
`;

const EmailContainer = styled.div`
  height: max-content;
  width: 100%;
  padding: 10px 15px;
  gap: 10px;
  display: grid;
  grid-template-columns: 1fr max-content;
  align-items: center;
  border-radius: 7px;
  background-color: ${globalTheme.colors.neutral};
  &:not(.active) {
    display: none;
  }
`;

const ActionButton = styled(Button)`
  width: 200px;
  height: 44px;
`;

const ModalText = styled(Text)`
  text-align: center;
`;

const MessageShareLink = styled.a`
  text-decoration: none;
`;

interface ListingsDialogProps {
  updateShareListing: Function;
  openShareListing: boolean;
  updateOpenLoginDialog: Function;
  openLoginDialog: boolean;
  listingDetails?: ListingRead;
}
export const ListingDetailDialog = ({
  updateShareListing,
  openShareListing,
  updateOpenLoginDialog,
  openLoginDialog,
  listingDetails,
}: ListingsDialogProps) => {
  const router = useRouter();
  const [shareUrl, setShareUrl] = useState<string>('');

  useEffect(() => {
    if (listingDetails) {
      setShareUrl(
        window.location.origin + buildPublicListingPath(listingDetails)
      );
    }
  }, [listingDetails]);

  const closeLoginDialog = () => {
    updateOpenLoginDialog(false);
  };

  const onClickLoginBtn = () => {
    const urlToSave = shareUrl.split('/').splice(3, 4).join('/');
    localStorage.setItem(REDIRECT_URL, urlToSave);
    signIn();
  };

  const closeShareListing = () => {
    updateShareListing(false);
  };

  return (
    <>
      {/* Open Login Dialog Section */}
      <Dialog
        title={'Ask a question'}
        isOpen={openLoginDialog}
        onDismiss={closeLoginDialog}
        overlayBackgroundColour={rgba(0, 0, 0, 0.3)}
        hasBlurredOverlay={false}
      >
        <ModalText>
          Found a deal ? Continue to login to <b>Ask a question</b>
        </ModalText>
        <ButtonContainer>
          <Button
            size='medium'
            type='button'
            data-cy='submitButton'
            onClick={onClickLoginBtn}
          >
            Continue to Login
          </Button>
        </ButtonContainer>
      </Dialog>

      {/* Share Listing Dialog Section */}
      <ShareListingDialog
        isOpen={openShareListing}
        onDismiss={closeShareListing}
        shareUrl={shareUrl}
        listingDetails={listingDetails}
      />
    </>
  );
};
